// user add
export const ADD_USER_LOADING = "user/add/laoding";
export const ADD_USER_SUCCESS = "user/add/success";
export const ADD_USER_ERROR = "user/add/error";
//get user
export const GET_USER_LOADING = "user/get/laoding";
export const GET_USER_SUCCESS = "user/get/success";
export const GET_USER_ERROR = "user/get/error";